import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { useInvalidateQuery as useInvalidateNotificationQuery } from "@faire/web-api--source/endpoints/www/api/retailer/notifications/get-hooks";
import { useState, useEffect } from "react";

export const useNotificationRealTimeUpdate = () => {
  const { notificationUpdateState } = useUserStore(["notificationUpdateState"]);
  const {
    latestStatusUpdate: baseLatestStatusUpdate,
    unviewedActiveNotificationCount: baseUnviewedActiveNotificationCount,
  } = notificationUpdateState ?? {};

  const [latestStatusUpdate, setLatestStatusUpdate] = useState(
    baseLatestStatusUpdate
  );
  const [unviewedActiveNotificationCount, setUnviewedActiveNotificationCount] =
    useState(baseUnviewedActiveNotificationCount);
  const invalidateNotificationQuery = useInvalidateNotificationQuery();

  useEffect(() => {
    // Making sure we update when the count or type of notification changes
    // This is controlled by SEND_WEB_SOCKET_MESSAGE_FOR_NOTIFICATIONS_HACK_WEEK_XP_241218
    // on BE
    if (
      latestStatusUpdate !== baseLatestStatusUpdate ||
      unviewedActiveNotificationCount !== baseUnviewedActiveNotificationCount
    ) {
      invalidateNotificationQuery();
      setLatestStatusUpdate(baseLatestStatusUpdate);
      setUnviewedActiveNotificationCount(baseUnviewedActiveNotificationCount);
    }
  }, [
    baseLatestStatusUpdate,
    baseUnviewedActiveNotificationCount,
    invalidateNotificationQuery,
    latestStatusUpdate,
    unviewedActiveNotificationCount,
  ]);
};
